import { render, staticRenderFns } from "./connect-settings.page.vue?vue&type=template&id=c5460b8c&scoped=true&"
import script from "./connect-settings.page.vue?vue&type=script&lang=js&"
export * from "./connect-settings.page.vue?vue&type=script&lang=js&"
import style0 from "./connect-settings.page.vue?vue&type=style&index=0&id=c5460b8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5460b8c",
  null
  
)

export default component.exports